import { createSlice } from '@reduxjs/toolkit';

export type MessageType = "info" | "warn" | "error";

// MessageState 型を定義
interface MessageState {
  isOpenModal: boolean;
  message: string;
  detail: string;
  type: MessageType
}

// initialState を定義
const initialState: MessageState = {
  isOpenModal: false,
  message: '',
  detail: '',
  type: "info" as MessageType,
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (state, action: {payload: {message: string, type: MessageType, detail?: string}}) => {
      state.isOpenModal = true;
      state.message = action.payload.message;
      state.detail = action.payload.detail ?? '';
      state.type = action.payload.type;
    },
    closeMessage: (state, action) => {
      state.isOpenModal = false;
      state.message = '';
      state.detail = '';
    }
  },
});

export const { setMessage, closeMessage } = messageSlice.actions;
export default messageSlice.reducer;
